import getStandaloneHost from 'ff/common/components/getStandaloneHost';
import { FFEmblem, LogoWithBoeing } from '../Icons/IconFFEmblem';
import { JeppesenEmblem, LogoWithJeppesen } from '../Icons/JeppesenEmblem';
import {
    hasDispatchLowca,
    hasFliteBrief,
    hasFliteLink,
    hasJeppesenMaDispatch,
} from 'ff/common/system';

const host = getStandaloneHost() || '';
export default function appendLogo(root: ShadowRoot) {
    const el = document.createElement('a');

    const isJeppesenDispatchUser =
        hasDispatchLowca() ||
        hasJeppesenMaDispatch() ||
        hasFliteLink() ||
        hasFliteBrief();

    const emblem = isJeppesenDispatchUser
        ? JeppesenEmblem({ margin: '0 1px 5px 5px' })
        : FFEmblem({ margin: '0 5px 0 12px' });
    const logo = isJeppesenDispatchUser
        ? LogoWithJeppesen({ margin: '2px 0px 5px 0px' })
        : LogoWithBoeing({ margin: '2px 0 0' });

    el.setAttribute('href', `${host}/`);
    el.setAttribute('id', 'logo-wrapper');

    el.appendChild(emblem);
    el.appendChild(logo);

    root.appendChild(el);
}
